import "./css/dc.css";
// ----------------------------------------------------css file--------------------------------------------------------------------

import { Formik, useFormik } from "formik";
import InputMask from "react-input-mask";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { useRef } from "react";
// import banner_lg from "../directCharge/img/img-dc-lg.svg";
// import banner_md from "../directCharge/img/img-dc-md.svg";
// import banner_sm from "../directCharge/img/img-dc-sm.svg";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";

// ----------------------------------------------------library react that import--------------------------------------------------------------------

import { useAPIDirectCharge } from "../../tools/api";
import { complexDigitToman, convertPersian, validationMessage } from "../../tools/tools";

// ----------------------------------------------------Personal file import--------------------------------------------------------------------

const IndexDC = () => {
  const { queryValidChargeByPlanId, isValidMSISDNToBuyCharge, queryGateWayByPlanId, redirectDCToIPGBankGateWay, redirectDCToAsanWallet } =
    useAPIDirectCharge();

  // ----------------------------------------------------import api service from apiDirect--------------------------------------------------------------------

  const array_getway = [20068, 20104];
  const [number, setNumber] = useState("");
  const [randomValue, setRandomValue] = useState(false);
  const [pouria, setPouria] = useState([]);
  const [getWay, setGetWay] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState(array_getway[parseInt(Math.random() * array_getway.length)]);

  // ----------------------------------------------------define stateStorage--------------------------------------------------------------------

  const bankRef = useRef("");
  const inputRef = useRef(null);

  const buttons = document.querySelectorAll(".btn_group_price span");

  const handleBankSelect = (bankId) => {
    setSelectedBankId(bankId);
    formik.setValues({
      ...formik.values,
      bankId,
    });
  };

  useEffect(() => {
    if (randomValue && inputRef.current) {
      inputRef.current.focus();
    }
  }, [randomValue]);
  // ---------------------------------------------------- The number of the active port for payment -----------------------------------------------------

  const handlePaymentBank = async (item) => {
    if (item.bankId == 20069) {
      const response = await redirectDCToAsanWallet(item);
      if (response) {
        window.location.href = response.url;
      }
    } else {
      const response = await redirectDCToIPGBankGateWay(item);
      if (response) {
        if (response.includes("html")) {
          bankRef.current.innerHTML = response;
          bankRef.current.querySelector('form[action="https://asan.shaparak.ir"]').submit();
        } else if (response.includes("form")) {
          bankRef.current.innerHTML = response;
          bankRef.current.querySelector("form")?.removeAttribute("target");
          bankRef.current.querySelector('input[type="submit"]')?.remove();
          bankRef.current.querySelectorAll("input")[1]?.setAttribute("type", "hidden");
          bankRef.current.querySelectorAll("input")[2]?.setAttribute("type", "hidden");
          bankRef.current.querySelector("form")?.submit();
        } else {
          window.location.href = response;
        }
      }
    }
  };

  // ---------------------------------------------------- Find out which port the user has selected-----------------------------------------------------

  const QueryValidChargeList = async () => {
    let req = { planid: process.env.REACT_APP_DC_BANKID_WALLET };
    let response = await queryValidChargeByPlanId(req);
    response.sort(function (a, b) {
      return a - b;
    });
    setPouria(response);
  };

  // ----------------------------------------------------  The function of calling the price list of packages -----------------------------------------------------

  const IsValidMSISDNToBuyCharge = async (item) => {
    let req = { msisdn: item, planid: process.env.REACT_APP_DC_BANKID_WALLET };
    let response = await isValidMSISDNToBuyCharge(req);
    return response;
  };

  // ----------------------------------------------------  Checking the phone number that can charge  -----------------------------------------------------

  const isqueryGateWayByPlanId = async () => {
    let req = { planid: process.env.REACT_APP_DC_BANKID_WALLET };
    let allresponse = await queryGateWayByPlanId(req);
    // let finalresponse = allresponse.filter((item) => item.bankType != 6);
    let isbankIdActive = allresponse.filter((item) => item.isDefault === true);
    setGetWay(allresponse);

    // setSelectedBankId(isbankIdActive[0].bankId);
  };

  // ----------------------------------------------------  The function List of payment gateways -----------------------------------------------------

  useEffect(() => {
    QueryValidChargeList();
    isqueryGateWayByPlanId();
    // console.log(getWay);
  }, []);

  // ----------------------------------------------------listed price and gateway after each load--------------------------------------------------------------------

  const formik = useFormik({
    initialValues: {
      msisdn: "", // phoneNumber
      amount: "", // Charge amount
      bankId: selectedBankId, // Payment gateway number
      planid: process.env.REACT_APP_DC_BANKID_WALLET,
      walletuser: "", //  The phone number in which the app wallet is active
    },
    validateOnBlur: "true",
    validationSchema: yup.object({
      walletuser:
        selectedBankId == 20069
          ? yup
              .string()
              .required(validationMessage.required)
              .test("underscore", validationMessage.required, (value) => {
                if (value && value.includes("_")) {
                  return false;
                }
                return true;
              })
          : "",
      msisdn: yup
        .string()
        .required(validationMessage.required)
        .test("underscore", validationMessage.required, (value) => {
          if (value && value.includes("_")) {
            return false;
          }
          return true;
        }),
      amount: yup
        .string()
        .matches(/^[0-9,]*$/, validationMessage.digits)
        .test("is-multiple-of-thousand", validationMessage.charge, (value) => {
          const number = parseInt(value.replace(/,/g, ""));
          return number % 10000 === 0;
        })
        .test("is-less-than-or-equal-to-max-charge", validationMessage.charge, (value, { parent }) => {
          const maxCharge = 2000000;
          const number = parseInt(value.replace(/,/g, ""));
          return number <= maxCharge;
        })
        .test("is-greater-than-or-equal-to-min-charge", validationMessage.charge, (value, { parent }) => {
          const minCharge = 20000;
          const number = parseInt(value.replace(/,/g, ""));
          return number >= minCharge;
        })
        .required(validationMessage.required),
      bankId: yup.string().required(validationMessage.required),
    }),
    onSubmit: (values, { setSubmitting }) => {
      let mssidn_charge = 0 + values.msisdn.replace(/\s+/g, "");
      IsValidMSISDNToBuyCharge(mssidn_charge).then((res) => {
        if (res) {
          handlePaymentBank(values);
        } else {
          setSubmitting(false);
        }
      });
    },
  });

  // ------------------------------------------------ Use formic hook to create information inside the form ----------------------------------

  const handleSubmit = (e) => {
    e.preventDefault();
    formik.setFieldValue("msisdn", formik.values.msisdn.replace(/\s+/g, "").replace(/^0+/, ""));
    formik.handleSubmit();
  };

  // -------------------------------------------- Function to separate zero first number and set inside initialstate -----------------------------------------------

  const activeBtn = (item, price) => {
    buttons.forEach((btn) => {
      btn.classList.remove("active");
    });

    if (item == 5) {
      setRandomValue(true);
    } else {
      setRandomValue(false);
    }
    formik.setValues({
      ...formik.values,
      amount: price.toString(),
    });
    document.getElementById(`${item}`).classList.add("active");
  };

  // --------------------------------------------------------------------- Show activation button --------------------------------------------------

  function formatNumber(number) {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // ---------------------------------------------------- The function of separating three digits of the input charge amount ------------------------------------------

  // ------------------------------------------------------- Generated html code -----------------------------------------------------------------------------------

  return (
    <div className="container-fluid dir-charge">
      <div className="row col-12 d-flex justify-content-center">
        <div className="col-12 p-0">
          {/* ----------------------------------------------------------------- banner image in page ------------------------------------------------------------------------ */}
          <figure className="col-12">
            <picture>
              <source media="(min-width:1024px)" srcSet={process.env.REACT_APP_ROOT_PATH_DC + "/packages/content/images/directCharge/img-dc-md.svg"} />
              <source media="(min-width:320px)" srcSet={process.env.REACT_APP_ROOT_PATH_DC + "/packages/content/images/directCharge/img-dc-sm.svg"} />
              <img sizes="100%" className="col-12" src={process.env.REACT_APP_ROOT_PATH_DC + "/packages/content/images/directCharge/img-dc-lg.svg"} alt="" />
            </picture>
            <figcaption style={{ backgroundColor: "#F5F5F5", display: "flex" }} className="d-flex justify-content-center">
              <div className="bread_crumb_wrapper p-2">
                <span className="ml-2">
                  <HomeOutlinedIcon fontSize="medium" />
                </span>
                <span className="ml-2">
                  <ArrowBackIosNewOutlinedIcon fontSize="small" />
                </span>
                <span>خرید شارژ</span>
              </div>
            </figcaption>
          </figure>
          {/* ----------------------------------------------------------------- banner image in page ------------------------------------------------------------------------ */}
        </div>
        <div className="box-charge d-flex justify-content-center">
          <div className="box-elem">
            <div className="top_box d-flex flex-column align-items-center">
              <div className="inner_top_box">
                <span>لطفا شماره موبایل خود را وارد کنید</span>
                <div className="form-group">
                  <form onSubmit={(e) => handleSubmit(e)}>
                    <InputMask
                      className="inp_mssidn_charge"
                      mask="0\9\9\9 999 99 99"
                      placeholder="0999 ___ __ __"
                      value={formik.values.msisdn}
                      onChange={(e) => {
                        e.target.value = convertPersian(e.target.value);
                        formik.handleChange(e);
                      }}
                      onBlur={(e) => {
                        // let value = e.target.value;
                        // if (
                        //   value.replace(/\s/g, "").length == 11 &&
                        //   !value.includes("_")
                        // ) {
                        //   IsValidMSISDNToBuyCharge(
                        //     e.target.value.replace(/\s/g, "")
                        //   );
                        // }

                        formik.handleBlur(e);
                      }}
                      type="text"
                      inputMode="numeric"
                      id="msisdn_charge"
                      name="msisdn"
                      dir="ltr"
                    />
                    {formik.touched.msisdn && formik.errors.msisdn ? <span className="err-txt">{formik.errors.msisdn}</span> : ""}
                    <div className="btn_group_price">
                      {pouria.map((item, index) => (
                        <span key={index} onClick={() => activeBtn(index, item)} id={index}>
                          {complexDigitToman(item)} تومان
                        </span>
                      ))}
                      <span
                        onClick={() => {
                          activeBtn(5, "");
                        }}
                        id="5"
                      >
                        مبلغ دلخواه
                      </span>
                    </div>
                    {randomValue && (
                      <div className="parent_random_charge mt-3 d-flex">
                        <input
                          className="random_charge text-left pl-2"
                          value={number}
                          onChange={(e) => {
                            const value = e.target.value.replace(/,/g, "");
                            setNumber(formatNumber(value));
                            formik.handleChange(e);
                          }}
                          onBlur={(e) => {
                            formik.handleBlur(e);
                            formik.setValues({
                              ...formik.values,
                              amount: number.replace(/,/g, "") + 0,
                            });
                          }}
                          type="text"
                          id="input_random_charge"
                          name="amount"
                          dir="ltr"
                          autoComplete="off"
                          maxLength="7"
                          ref={inputRef}
                        />
                        <span className="txt-beside-input">تومان</span>
                      </div>
                    )}
                    {formik.errors.amount && formik.touched.amount ? <span className="err-txt">{formik.errors.amount}</span> : ""}
                    <div className="holder-gatway">
                      <ul className="list-unstyled mt-3">
                        {getWay.map((item, index) => (
                          <li key={item.bankId}>
                            <div className="row-getway  mb-2">
                              <div className="form-check">
                                <label>
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name="selected_price"
                                    value={item.bankId}
                                    checked={selectedBankId == item.bankId}
                                    onChange={() => {
                                      handleBankSelect(`${item.bankId}`);
                                    }}
                                  />
                                  {item.faBankName}
                                </label>
                              </div>
                              {selectedBankId == 20069 && item.bankType == 3 && (
                                <div className="wrapper-wallet-app">
                                  <p className="title-wrapper">لطفا شماره موبایلی با آن اپلیکیشن آپ خود را فعال کرده‌اید وارد کنید.</p>
                                  <div className="d-flex mb-3">
                                    <div className="continue w-25">
                                      <button type="submit" className="btn btn-normal w-100 " style={{ padding: "1rem 0" }}>
                                        ادامه
                                      </button>
                                      {formik.errors.walletuser && formik.touched.walletuser && (
                                        <div className="err-txt-wrem">{formik.errors.walletuser}</div>
                                      )}
                                    </div>
                                    <div className="row-item w-75">
                                      <div className="holder-prefix">
                                        <InputMask
                                          mask="0\999 999 99 99 "
                                          placeholder="09__ ___ __ __"
                                          dir="ltr"
                                          type="text"
                                          inputMode="numeric"
                                          onChange={(e) => {
                                            formik.setFieldValue("walletuser", e.target.value);
                                          }}
                                          onBlur={(e) => {
                                            formik.setFieldValue("walletuser", e.target.value.replace(/\s+/g, ""));
                                          }}
                                          value={formik.values.walletuser}
                                          name="walletuser"
                                          className=" input-in-wallet form-control w-100"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <button className={`${selectedBankId == 20069 ? "disabled" : ""} btn btn-normal pay-btn`} type="submit">
                      پرداخت
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <hr />
            <div className="bottom_box d-flex ">
              <div className="right mx-2">
                <i className="icon-info"></i>
              </div>

              <div>
                <span>
                  مبالغ با احتساب مالیات بر ارزش افزوده است. مشترک گرامی، لطفاً از درستی شماره وارد شده اطمینان حاصل فرمائید. در صورت ورود شماره
                  اشتباه، امکان انتقال شارژ خریداری شده یا عودت مبلغ آن وجود نخواهد داشت.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref={bankRef}></div>
    </div>
  );
};
export default IndexDC;
